import { render, staticRenderFns } from "./ex-details.vue?vue&type=template&id=0e7736aa&scoped=true&"
import script from "./ex-details.vue?vue&type=script&lang=js&"
export * from "./ex-details.vue?vue&type=script&lang=js&"
import style0 from "./ex-details.vue?vue&type=style&index=0&id=0e7736aa&scoped=true&lang=scss&"
import style1 from "./ex-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7736aa",
  null
  
)

export default component.exports